// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"09fd1fc4","207":"c29fab3d","213":"6b31146f","239":"99ddee8b","368":"5a03ce59","453":"ae9c510e"}[chunkId] + ".chunk.js";
};